import styled from 'styled-components';
import FontAwesome from 'react-fontawesome';
import { theme } from '../../config/theme';
import { sizes } from '../../config/general';

export const Link = styled.a`
	color: ${theme.text.primary.color};
	text-decoration: none;
	padding-left: 20px;
	float: left;	
	font-size: 1.2em;
	font-weight: 100;
	padding-right: ${props => props.mobile ? '10px' : 'unset'};
	padding-top: ${props => props.mobile ? '5px' : 'unset'};
	padding-bottom: ${props => props.mobile ? '5px' : 'unset'};
	animation: v38FadeIn 2s;		

	&:hover {
		cursor: pointer;
		color: ${theme.text.primary.active};
		text-decoration: none;
	}

	&:before {
		content: "";
		width: 100%;
		height: 1px;
		background-color: ${theme.text.primary.active};
		visibility: hidden;
		transform: scaleX(0);
		transition: all 0.3s ease-in-out 0s;
	}

	&:hover:before {
		visibility: visible;
		-webkit-transform: scaleX(1);		
		transform: scaleX(1);
	}
`;

export const NavWrapper = styled.div`
	height: ${sizes.nav.height.desktop};
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	background-color: black;
	z-index: 9999;
	box-shadow: 0px 10px 10px 5px black;	
`;

export const LinkWrapper = styled.span`
	margin-left: auto;
	padding-right: 20px;
`;

export const LinkWrapperFixed = styled.span`
	position: fixed;
	right: 0;
	top: 10px;
	border-left: 1px solid white;
	border-top: 1px solid white;
	border-bottom: 1px solid white;
	background-color: black;
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
	transform: TranslateX(${props => props.visible ? '0' : '200px'});
	transition: transform 0.7s;
`;

export const Logo = styled.img`
	height: 70%;
	padding-left: 20px;
`;

export const Icon = styled(FontAwesome)`
	color: white;
	font-size: 1.4em !important; 
	font-weight: 100;
	padding-right: 10px;
	animation: v38FadeIn 2s;	
`;

export const IconClose = Icon.extend`
	position: fixed;
	top: 0;
	left: -25%;
	font-size: 1.4em !important; 	
`;


// WEBPACK FOOTER //
// ./src/components/navigation/components.js